import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    drawer: null,
    authToken: localStorage.getItem("authToken") || null,
    packages: null,
  },
  getters: {
    axiosConfig: (state) => {
      const authConfig = {
        headers: {
          Authorization: state.authToken,
        },
      };
      return state.authToken ? authConfig : {};
    },
  },
  mutations: {
    toggleDrawer(state, value) {
      state.drawer = value;
    },
    updateAuthToken(state, value) {
      state.authToken = value;
    },
    updatePackages(state, value) {
      state.packages = value;
    },
    updatePackage(state, newPackageData) {
      const packageIndex = state.packages.findIndex(
        (packageData) => packageData.id === newPackageData.id
      );
      Vue.set(state.packages, packageIndex, newPackageData);
    },
  },
  actions: {
    setAuthToken(context, newToken) {
      localStorage.setItem("authToken", newToken);
      context.commit("updateAuthToken", newToken);
    },
    removeAuthToken(context) {
      localStorage.removeItem("authToken");
      context.commit("updateAuthToken", null);
    },
  },
  modules: {},
});
